import { useMemo } from 'react';

import { getTickValues } from '../utils/getTickValues';
import { ScaleWithValueType } from '../utils/SupportedScale';

export const useTickValues = <T extends unknown>({
  scale,
  tickCount,
  ticks,
}: {
  scale: ScaleWithValueType<T>;
  tickCount: number | undefined;
  ticks: T[] | undefined;
}): T[] => {
  return useMemo(
    () =>
      getTickValues({
        scale,
        tickCount,
        ticks,
      }),
    [scale, tickCount, ticks],
  );
};
